export default {
	dispatchEventStroage() {
		const signSetItem = localStorage.setItem
		localStorage.setItem = function (key, val) {
			let setEvent = new Event('setItemEvent')
			setEvent.key = key
			setEvent.newValue = val
			window.dispatchEvent(setEvent)
			signSetItem.apply(this, arguments)
		}
	},
	// dispatchEventRemove() {
	// 	const orignalremoveItem = localStorage.removeItem
	// 	localStorage.removeItem  = function (key) {
	// 		let removeItemEvent  = new Event('removeItemEvent')
	// 		removeItemEvent.key = key
	// 		// removeItemEvent.newValue = val
	// 		window.dispatchEvent(removeItemEvent)
	// 		orignalremoveItem.apply(this, arguments)
	// 	}
	// }
}